import {
  // useCallback,
  useEffect, useRef, useState,
} from 'react'
import { Button, DatePicker, Input, Row, Select, Table } from 'antd'
import type { ColumnsType } from 'antd/es/table'
import * as Cesium from '@cesiumgs/cesium-analytics'
import dayjs from 'dayjs'
import { MODAL_WIDTH, MODAL_WIDTH_RESULT, resultArr2 as resultArr2Copy, resultArr as resultArrCopy, selectArr } from './data'
import Popup from './popup'
import RenderKeyValue2Array from '@/components/Content/RenderKeyValue2Array'
import { debounce } from '@/utils/rightNavCtrl'
import Home from '@/pages/Home'
import Modal from '@/components/Modal'
import { IGetAllData, IGetResult } from '@/service/ruralBusiness'
import useStore from '@/hooks/useStore'
import './index.less'

const { Search } = Input

let billboardDataSource: any = null
const BILLBOARD_NAME = 'BILLBOARD_NAME'
let mouseMoveEvent: any = null
let mouseClickEvent: any = null
const POPUP_WIDTH = 300
const DATE_FORMAT = 'YYYY'
let positionClick: any = null
let pick: any = null
const TIMEOUT = 2000
function RuralBusiness() {
  const uiStore = useStore('uiStore')
  const rightNavCtrlStore = useStore('rightNavCtrlStore')
  const mapStore = useStore('mapStore')
  const facilityStore = useStore('facilityStore')

  const [selectValue, setSelectValue] = useState(selectArr[0].value)
  const [inputValue, setInputValue] = useState('')
  const [startDate, setStartDate] = useState<any>(null)
  const [endDate, setEndDate] = useState<any>(null)
  const [showModal, setShowModal] = useState(false)
  const [showModalResult, setShowModalResult] = useState(false)
  const [tableData, setTableData] = useState([])
  const [tableDataResult, setTableDataResult] = useState<any>([])
  const [total, setTotal] = useState(0)
  const [pageIndex, setPageIndex] = useState(1)
  const [currentClick, setCurrentClick] = useState<any>(null) // 1: hide, have value: show
  const [resultArr, setResultArr] = useState<any>(resultArrCopy)
  const [resultArr2, setResultArr2] = useState<any>(resultArr2Copy)
  const [renderMap, setRenderMap] = useState<any>(false)
  const [mapLoaded, setMapLoaded] = useState<any>(false)
  const [homeKey, setHomeKey] = useState<any>(Math.random())
  const [callbackViewer, setCallbackViewer] = useState<any>(null)
  const popupRef = useRef<any>(null)
  const columns: ColumnsType<any> = [
    {
      title: '지구(사업)명',
      dataIndex: 'zoneName',
      key: 'zoneName',
    },
    {
      title: '사업유형',
      dataIndex: 'btypNm',
      key: 'btypNm',
    },
    {
      title: '사업년도',
      dataIndex: 'year',
      key: 'year',
    },
    {
      title: '사업위치',
      dataIndex: 'bizLocation',
      key: 'bizLocation',
    },
  ]

  const columnsResult: ColumnsType<any> = [
    {
      title: '사업명',
      dataIndex: 'bizNm',
      key: 'bizNm',
    },
    {
      title: '기능',
      dataIndex: 'fntpNm',
      key: 'fntpNm',
    },
    {
      title: '착공일',
      dataIndex: 'outsetDate',
      key: 'outsetDate',
    },
    {
      title: '준공일',
      dataIndex: 'competDate',
      key: 'competDate',
    },
  ]

  // from route
  useEffect(() => {
    checkFromUrl() // logic from routing
  }, [])

  // from click menu
  useEffect(() => {
    if (uiStore.isClickRural) {
      if (window.cviewer) {
        billboardDataSource = new Cesium.CustomDataSource('billboardDataSource')
        window.cviewer.dataSources.add(billboardDataSource)
        window.cviewer.scene.postRender.addEventListener(updatePopupPosition)
        // cameraChange()
      }
      return () => {
        window.cviewer.scene.postRender.removeEventListener(updatePopupPosition)
      }
    }
  }, [uiStore.isClickRural])

  useEffect(() => { // logic from routing
    if (!callbackViewer)
      return
    if (window.cviewer) {
      billboardDataSource = new Cesium.CustomDataSource('billboardDataSource')
      window.cviewer.dataSources.add(billboardDataSource)
      window.cviewer.scene.postRender.addEventListener(updatePopupPosition)
      // cameraChange()
    }

    return () => {
      window.cviewer.scene.postRender.removeEventListener(updatePopupPosition)
    }
  }, [callbackViewer])

  const checkFromUrl = () => {
    const url = window.location.href
    const { viewer } = mapStore
    if (url.includes('ruralBusiness')) {
      if (viewer) {
        setRenderMap(false)
      }
      else {
        setRenderMap(true)
      }
    }
  }

  const mapLoadedCallback = (viewer: any) => { // logic from routing
    if (viewer) {
      uiStore.showRuralBusiness(true)
      facilityStore.showFacilityInfo(false)
      setCallbackViewer(viewer)
    }
  }

  const cameraChangeFn = () => {
    // const rectangle = window.cviewer.camera.computeViewRectangle()
    // const northeastRadians: Cesium.Cartographic = Cesium.Rectangle.northeast(rectangle)
    // const southwestRadians: Cesium.Cartographic = Cesium.Rectangle.southwest(rectangle)
    // const northeastDegrees = {
    //   longitude: radiansToDegrees(northeastRadians.longitude),
    //   latitude: radiansToDegrees(northeastRadians.latitude),
    // }
    // const southwestDegrees = {
    //   longitude: radiansToDegrees(southwestRadians.longitude),
    //   latitude: radiansToDegrees(southwestRadians.latitude),
    // }
    // const params = {
    //   neLng: northeastDegrees.longitude,
    //   neLat: northeastDegrees.latitude,
    //   seLng: southwestDegrees.longitude,
    //   seLat: southwestDegrees.latitude,
    //   apiKey: window.SystemConfig.facilityApiKey,
    // }
    const extend: any = window.cviewer.camera.computeViewRectangle()
    const neLng: any = Cesium.Math.toDegrees(extend.east)
    const neLat: any = Cesium.Math.toDegrees(extend.north)
    const seLng: any = Cesium.Math.toDegrees(extend.west)
    const seLat: any = Cesium.Math.toDegrees(extend.south)
    const params: object = {
      apiKey: window.SystemConfig.facilityApiKey,
      neLng,
      neLat,
      seLng,
      seLat,
      // pageIndex: 1,
    }
    IGetAllData(params).then((res: any) => {
      if (res.code === 200) {
        const { result = [] } = res
        if (result.length > 0) {
          rightNavCtrlStore.handleShowPolygonOnMap(false)
          const res2 = combinedBillboardData(result)
          drawBillboard(res2)
        }
        else {
          rightNavCtrlStore.handleShowPolygonOnMap(false)
          removeBillboard()
        }
      }
    })
  }

  const cameraChange = () => {
    const changeCallback = function () {
      cameraChangeFn()
    }

    const debouncedSave = debounce(() => changeCallback(), TIMEOUT)

    window.cviewer.camera.changed.addEventListener(debouncedSave)
  }

  const drawBillboard = (arr: any) => {
    removeBillboard()
    let billboardEntity: any = null
    for (let i = 0; i < arr.length; i++) {
      const item = arr[i]
      const { coordinates } = item.geometry
      billboardEntity = new Cesium.Entity({
        id: BILLBOARD_NAME + i,
        name: item.properties,
        position: Cesium.Cartesian3.fromDegrees(coordinates[0], coordinates[1], 0),
        billboard: {
          image: './img/rural-point.png',
          width: 30,
          height: 30,
          scale: 1,
          verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
          horizontalOrigin: Cesium.HorizontalOrigin.CENTER,
          disableDepthTestDistance: Number.POSITIVE_INFINITY,
          distanceDisplayCondition: new Cesium.DistanceDisplayCondition(0, 10000000),
        },
      })
      billboardDataSource.entities.add(billboardEntity)
    }
    // window.cviewer.zoomTo(billboardDataSource)
    moveAndClick()
  }

  const removeBillboard = () => {
    if (billboardDataSource && Array.isArray(billboardDataSource.entities.values) && billboardDataSource.entities.values.length > 0) {
      billboardDataSource.entities.removeAll()
    }
  }

  const updatePopupPosition = () => {
    if (pick && pick.id && pick.id.position) {
      positionClick = pick.id.position._value
      const cartographic = Cesium.Cartographic.fromCartesian(positionClick)
      const longitude = Cesium.Math.toDegrees(cartographic.longitude)
      const latitude = Cesium.Math.toDegrees(cartographic.latitude)
      const windowCoord = Cesium.SceneTransforms.wgs84ToWindowCoordinates(window.cviewer.scene, Cesium.Cartesian3.fromDegrees(longitude, latitude, 0))
      const obj = {
        sx: windowCoord.x + POPUP_WIDTH + POPUP_WIDTH / 6,
        sy: windowCoord.y,
      }
      if (popupRef && popupRef.current) {
        popupRef.current.handleSetStyle && popupRef.current.handleSetStyle(obj)
      }
    }
  }

  const moveAndClick = () => {
    mouseMoveEvent = new Cesium.ScreenSpaceEventHandler(window.cviewer.scene.canvas)
    mouseClickEvent = new Cesium.ScreenSpaceEventHandler(window.cviewer.scene.canvas)

    mouseClickEvent.setInputAction((movement: any) => {
      pick = window.cviewer.scene.pick(movement.position)
      if (pick && pick.primitive && pick.primitive instanceof Cesium.Billboard && pick.id && pick.id.name && pick.id.name.customName && pick.id.name.customName.includes(BILLBOARD_NAME)) {
        positionClick = pick.id.position._value
        const cartographic = Cesium.Cartographic.fromCartesian(positionClick)
        const longitude = Cesium.Math.toDegrees(cartographic.longitude)
        const latitude = Cesium.Math.toDegrees(cartographic.latitude)
        const windowCoord = Cesium.SceneTransforms.wgs84ToWindowCoordinates(window.cviewer.scene, Cesium.Cartesian3.fromDegrees(longitude, latitude, 0))
        const obj = {
          // sx: windowCoord.x + POPUP_WIDTH + POPUP_WIDTH / 6,
          sx: windowCoord.x,
          sy: windowCoord.y,
          ...pick.id.name,
        }
        setCurrentClick(obj)
      }
    }, Cesium.ScreenSpaceEventType.LEFT_CLICK)

    mouseMoveEvent.setInputAction((movement: any) => {
      const pick = window.cviewer.scene.pick(movement.endPosition)
      if (pick && pick.primitive && pick.primitive instanceof Cesium.Billboard && pick.id && pick.id.name && pick.id.name.customName && pick.id.name.customName.includes(BILLBOARD_NAME)) {
        (window.cviewer as any)._container.style.cursor = 'pointer'
      }
      else {
        (window.cviewer as any)._container.style.cursor = 'default'
      }
    }, Cesium.ScreenSpaceEventType.MOUSE_MOVE)
  }

  const searchPartHide = () => {
    uiStore.searchPartHide()
  }

  const selectChange = (value: any) => {
    setSelectValue(value)
  }

  const onSearch = (value: any) => {
    setInputValue(value)
    onSure(1, value)
  }

  const clearValue = () => {
    setSelectValue(selectArr[0].value)
    setInputValue('')
    setStartDate('')
    setEndDate('')
    removeBillboard()
  }

  const radiansToDegrees = (radians: any) => {
    return radians * (180 / Math.PI)
  }

  const combinedBillboardData = (result: any) => {
    const arr = []
    for (let i = 0; i < result.length; i++) {
      const item: any = result[i]
      const obj = {
        type: 'Feature',
        properties: {
          ...item,
          customName: BILLBOARD_NAME + i,
        },
        geometry: {
          coordinates: [item.x, item.y],
          type: 'Point',
        },
      }
      arr.push(obj)
    }
    return arr
  }

  const onSure = (pageIndex = 1, value = null) => {
    let minYear = null
    let maxYear = null

    const params: any = {
      sggCd: selectValue,
      searchKeyword: value || inputValue,
      apiKey: window.SystemConfig.facilityApiKey,
      // pageIndex,
    }
    if (startDate) {
      minYear = startDate.year()
      params.minYear = minYear
    }
    if (endDate) {
      maxYear = endDate.year()
      params.maxYear = maxYear
    }
    Object.entries(params).forEach(([key, value]) => {
      if (value === '') {
        delete params[key]
      }
    })
    // IGetData(params).then((res: any) => {
    IGetAllData(params).then((res: any) => {
      if (res.code === 200) {
        // const result = res.result.resultList
        const result = res.result
        if (result.length > 0) {
          result.forEach((item: any, index: number) => {
            item.key = index + 1
          })
          setShowModal(true)
          setTotal(res.result.totalCnt)
          setTableData(result)
          rightNavCtrlStore.handleShowPolygonOnMap(false)
          const res2 = combinedBillboardData(result)
          drawBillboard(res2)
        }
        else {
          setShowModal(true)
          setTotal(0)
          setTableData([])
          rightNavCtrlStore.handleShowPolygonOnMap(false)
          removeBillboard()
        }
      }
    })
  }

  const startDateChange = (date: any, dateString: string | string[]) => {
    const startDate = dayjs(dateString as string, DATE_FORMAT)
    setStartDate(startDate)
  }

  const endDateChange = (date: any, dateString: string | string[]) => {
    const endDate = dayjs(dateString as string, DATE_FORMAT)
    setEndDate(endDate)
  }

  const pageChange = (page: number) => {
    setPageIndex(page)
    onSure(page)
  }

  const onRow = (record: any) => {
    return {
      onClick: () => {
        handleRowClick(record)
      },
    }
  }

  const handleRowClick = (record: any) => {
    const params = {
      apiKey: window.SystemConfig.facilityApiKey,
      inbpnCode: record.inbpnCode,
    }
    const { x, y } = record
    window.cviewer.camera.flyTo({
      destination: Cesium.Cartesian3.fromDegrees(x, y, 5000),
      orientation: {
        heading: Cesium.Math.toRadians(0),
        pitch: window.cviewer.scene.camera.pitch,
        roll: window.cviewer.scene.camera.roll,
      },
      complete: () => { },
    })
    IGetResult(params).then((res: any) => {
      if (res.code === 200) {
        const {
          result,
          result: { dvlDetailList },
        } = res
        setShowModalResult(true)
        const arr = JSON.parse(JSON.stringify(resultArr))
        arr[0][0].value = result.zoneName
        arr[0][1].value = result.year
        arr[1][0].value = result.bizLocation
        arr[2][0].value = result.btypNm
        arr[3][0].value = result.contents
        setResultArr(arr)
        const arr2 = JSON.parse(JSON.stringify(resultArr2))
        arr2[0][0].value = result.location
        arr2[1][0].value = result.cpplanDate
        setResultArr2(arr2)
        if (Array.isArray(dvlDetailList) && dvlDetailList.length > 0) {
          setTableDataResult(dvlDetailList)
        }
        else {
          setTableDataResult([])
        }
      }
      else {
        setShowModalResult(false)
        setResultArr(resultArrCopy)
        setResultArr2(resultArr2Copy)
      }
    })
  }

  const clickCallback = (obj: any) => {
    handleRowClick(obj)
  }

  return (
    <>
      {
        renderMap
          ? <Home key={homeKey} mapLoadedCallback={mapLoadedCallback} />
          : <div className="ruralPart">
            <div className="rural-box">
              <div className="rural-box-con">
                <Row className="rural-box-con-one">
                  <Select value={selectValue} style={{ width: '100%' }} onChange={selectChange} options={selectArr} />
                </Row>
                <Row className="rural-box-con-two">
                  <DatePicker value={startDate} onChange={startDateChange} placeholder="사업 시작 연도" picker="year" format={DATE_FORMAT} style={{ width: '48%' }} />
                  <div style={{ margin: '0 1%' }}>~</div>
                  <DatePicker value={endDate} onChange={endDateChange} placeholder="사업 종료 년도" picker="year" format={DATE_FORMAT} style={{ width: '48%' }} />
                </Row>
                <Row className={'rural-box-con-three'}>
                  <Search
                    value={inputValue}
                    onChange={(e) => {
                      setInputValue(e.target.value)
                    }}
                    placeholder="검색어를 입력해주세요" onSearch={onSearch} />
                </Row>
                <Row className={'rural-box-con-four'}>
                  <Button className={'reset'} onClick={clearValue}>
                  <span translate="no">초기화</span>
                  </Button>
                  <Button onClick={() => onSure()} className={'sure'}>
                    검색
                  </Button>
                </Row>
              </div>
            </div>
            {currentClick && <Popup clickCallback={clickCallback} popupData={currentClick} ref={popupRef}></Popup>}

            {uiStore.SearchPartShow === true
              ? <div className={'hide-button'}>
                <button className={'btn-fold'} onClick={searchPartHide} />
              </div>
              : <div className={'hide-button'}>
                <button className={'btn-open'} onClick={searchPartHide} />
              </div>}

            <Modal
              visible={showModal}
              headerTitle={'검색결과'}
              handleClose={() => {
                setShowModal(false)
              }}
              styles={{
                position: 'fixed',
                width: MODAL_WIDTH,
                top: `${window.SystemConfig.uiConfig.headerHeight + 30}px`,
                left: `${uiStore.Content_Left_Width + 30}px`,
                zIndex: 10,
              }}
              isNotDragWithParent="dragModal_RuralBusiness"
            >
              <div className="rural-modal">
                <header>
                  검색결과 <span>{total}건</span>
                </header>
                <Table
                  className={'rural-modal-table'}
                  columns={columns}
                  dataSource={tableData}
                  pagination={{
                    position: ['bottomCenter'],
                    total,
                    showSizeChanger: false,
                    onChange: pageChange,
                  }}
                  onRow={onRow}
                />
              </div>
            </Modal>
            <Modal
              visible={showModalResult}
              headerTitle={'농촌개발사업 상세정보'}
              handleClose={() => {
                setShowModalResult(false)
              }}
              styles={{
                position: 'fixed',
                width: MODAL_WIDTH_RESULT,
                top: `${window.SystemConfig.uiConfig.headerHeight + 120}px`,
                left: `${uiStore.Content_Left_Width + 30 + 16}px`,
                zIndex: 10,
              }}
              isNotDragWithParent="dragModal_RuralBusiness_result"
            >
              <div className="rural-modal-result">
                <div>
                  <RenderKeyValue2Array contentArr={resultArr} />
                </div>
                <div>
                  <header>지구정보</header>
                  <RenderKeyValue2Array contentArr={resultArr2} />
                </div>
                <div>
                  <header>내역사업</header>
                  <Table
                    className={'rural-modal-table-result'}
                    columns={columnsResult}
                    dataSource={tableDataResult}
                    pagination={false}
                  // pagination={{
                  //   position: ['bottomCenter'],
                  //   total,
                  //   showSizeChanger: false,
                  //   onChange: pageChange,
                  // }}
                  />
                </div>
              </div>
            </Modal>
          </div>
      }
    </>
  )
}
export default RuralBusiness
